import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
import { JSEncrypt } from 'jsencrypt';
import { MyserviceService } from "../myservice.service";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.css"],
    providers: [MessageService]
})
export class LoginComponent implements OnInit {
    loader: boolean;
    environment: { dev: boolean; uat: boolean; prod: boolean; apiUrl: string; envName: string; };
    dialogHeader: string;
    forgot: string;
    loggedInUserInfo: any;
    webForms: boolean = false;
    mscvp: boolean = false;
    tpm: boolean = false;
    siteKey = '6Lebsn0pAAAAAA8VcYHyDOgxf-VCYlnV6D1-cSn4'
    recaptcha: any
    displayMFA: boolean;
    captchaText: string = '';
    captchaInput: string = '';
    globalColor: any;
    userForm: boolean = true;
    nonSsoUser: boolean = false;
    token: any;
    btn: string = "Next";
    encryptedKey: any;
    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private http: HttpClient,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private messageService: MessageService,
        private oauthService: OAuthService,
        private MyserviceService: MyserviceService
    ) { }
    loginModel: any = {};
    errorMsg = "";
    env = "";
    now: Date;
    display: boolean = false;
    displayAccess: boolean = false;
    document: any = {};
    passwordTextType: boolean;
    forgotPasswordResponse: string = "";
    email: string;
    envName: string;
    signInIcon: string = 'pi pi-lock';
    otp1: string = '';
    otp2: string = '';
    otp3: string = '';
    otp4: string = '';
    otp5: string = '';
    otp6: string = '';
    countdown: number;
    intervalId: any;

    currentIndex: number = 0;
currentMessage: string = '';
textMessages: string[] = [
//   'Message 1: Welcome to the platform',
//   'Message 2: Please review order details',
//   'Message 3: New feature released',
//   'Message 4: Scheduled maintenance on Sunday',
//   'Message 5: Contact support for help'
];
    ngOnInit() {
        this.localstorage.store("token", "")
        sessionStorage.clear();
        this.session.clear();

        this.generateCaptcha()
        this.localstorage.clear();
        this.session.clear();
        this.environment = environment
        this.envName = environment.envName;
        this.document.email = "";
        if (environment.dev == true) {
            this.env = "../assets/logo/dev/topbar_sub_integrator.gif";
        } else if (environment.uat == true) {
            this.env = "../assets/logo/uat/topbar_sub_integrator.gif";
        } else if (environment.prod == true) {
            this.env = "../assets/logo/prod/topbar_sub_integrator.gif";
        }

        this.ssotokenData();

        this.getListOfNotifications();
    }
    getListOfNotifications() {
        this.MyserviceService.getListOfNotifications().subscribe((data: any) => {
            console.log(data, "list of notifications");
            // this.textMessages = data.map((item: any) => {
            //     if(item.isactive) {
            //     return item.message
            //     }
            // });
            data.forEach(element => {
                if(element.isactive) {
                    this.textMessages.push(element.message);
                }
            });
            console.log(this.textMessages, "text messages");

            // this.currentMessage = this.textMessages[this.currentIndex];
            // setInterval(() => {
            //     this.currentIndex = (this.currentIndex + 1) % this.textMessages.length;
            //     this.currentMessage = this.textMessages[this.currentIndex];
            // }, 20000); // rotates every 3 seconds
            this.currentMessage = `◈   ` + this.textMessages.join('  ◈   ');
        }, err => {
            this.textMessages = [];
        });
    }
    ssotokenData() {
        // this.token = this.oauthService.getAuthorizationCode();
        // const state = this.oauthService.getState();
        console.log(this.token, "sso token");
        console.log('Access token available:', this.oauthService.getAccessToken());

        const claims: any = this.oauthService.getIdentityClaims();
        if (claims) {
            console.log('User Email:', claims.email);
            console.log('User Name:', claims.name);
            console.log("Username (UPN):", claims.preferred_username);
        }


        if (this.token != null) {
            const headers = new HttpHeaders({
                'Content-Type': 'application/json'
            });
            const ssoUser = {
                "email": "iwan.mardjoko"
            }
            this.http.post(environment.url + 'ediscv/token', ssoUser, { headers: headers })
                .subscribe((data) => {
                    console.log(data, "========data sso user");
                    this.router.navigate(['/mscvp/profile']);
                })
        }
    }





    startCountdown() {
        this.intervalId = setInterval(() => {
            if (this.countdown > 0) {
                this.countdown--;
            } else {
                clearInterval(this.intervalId); // stop the countdown when it reaches 0
            }
        }, 1000); // update every second
    }
    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId); // cleanup when component is destroyed
        }
    }
    getFormattedTime() {
        const minutes = Math.floor(this.countdown / 60);
        const seconds = this.countdown % 60;
        return `${this.padZero(minutes)}:${this.padZero(seconds)}`;
    }

    // Helper method to pad single digits with leading zero
    padZero(value: number): string {
        return value < 10 ? `0${value}` : `${value}`;
    }
    signIn(loginModel) {
        this.loader = true;
        this.httpClient
            .get(
                environment.apiUrl + "/key"
            ).subscribe((encryptionKey: any) => {
                console.log(encryptionKey, "encryptionKey");
                if (encryptionKey) {
                    // this.oauthService.initImplicitFlow();
                    this.encryptedKey = encryptionKey.key
                    setInterval(() => {
                        this.now = new Date();
                    }, 1);

                    const LOGIN_REQ_BODY = {
                        loginId: this.encryptUserName(loginModel.loginId),
                        password: this.encryptPassword(loginModel.password)
                    }

                    console.log(this.loginModel, "loginModel");
                    this.errorMsg = "";
                    if (
                        this.loginModel.loginId &&
                        this.loginModel.password &&
                        this.captchaInput &&
                        this.captchaInput !== this.captchaText
                    ) {
                        this.errorMsg = "Invalid CAPTCHA. Please try again.";
                        this.loader = false;
                        return;
                    }
                    if (
                        this.loginModel.loginId !== null &&
                        this.loginModel.loginId !== "" &&
                        this.loginModel.password !== null &&
                        this.loginModel.password !== "" && this.loginModel.password && this.loginModel.loginId &&
                        this.captchaInput === this.captchaText
                    ) {
                        this.httpClient
                            .post(
                                environment.apiUrl + "/login",
                                JSON.stringify(LOGIN_REQ_BODY),
                                {
                                    headers: new HttpHeaders({
                                        "Content-Type": "application/json",
                                    }),
                                    responseType: "text",
                                    observe: "response",
                                }
                            )
                            .subscribe(
                                (loginResponse: any) => {
                                    this.loader = false;
                                    console.log(loginResponse.headers.get("authorization"), "loginResponse");
                                    this.signInIcon = 'pi pi-spin pi-spinner';
                                    if (loginResponse.headers.get("authorization") != "") {
                                        this.localstorage.store(
                                            "token",
                                            loginResponse.headers.get("authorization")
                                        );
                                        let headers = new HttpHeaders({
                                            "Content-Type": "application/json",
                                        });
                                        headers = headers.append(
                                            "Authorization",
                                            loginResponse.headers.get("authorization")
                                        );
                                        // this.oAuthService.initImplicitFlow();
                                        this.httpClient
                                            .post(
                                                environment.apiUrl +
                                                "/getUserInfo",
                                                LOGIN_REQ_BODY,
                                                { headers: headers }
                                            )
                                            .subscribe(

                                                (loggedInUserInfo: any) => {
                                                    this.loggedInUserInfo = loggedInUserInfo
                                                    this.session.store("isLogIN", true);
                                                    this.session.store('password', this.loginModel.password)
                                                    this.session.store(
                                                        "UserDetails",
                                                        loggedInUserInfo
                                                    );
                                                    this.getConfig()
                                                    this.session.store(
                                                        "loginId",
                                                        loggedInUserInfo.loginId
                                                    );
                                                    this.session.store(
                                                        "isAllPartners",
                                                        loggedInUserInfo.isAllPartners
                                                    );
                                                    this.session.store(
                                                        "isAllSfgPartners",
                                                        loggedInUserInfo.isAllSfgPartners
                                                    );
                                                    const token1 = this.localstorage.retrieve("token")
                                                    // console.log("loggedin user", loggedInUserInfo);
                                                    if (loggedInUserInfo.isActive == "A") {

                                                        if (
                                                            loggedInUserInfo.userDefaultFlowID !=
                                                            ""
                                                        ) {
                                                            if (loggedInUserInfo.roleId === 2 || loggedInUserInfo.roleId === 3 || loggedInUserInfo.roleId === 6 || loggedInUserInfo.roleId === 7) {
                                                                this.router.navigate(["/mscvp/profile"]);
                                                            }
                                                            // else if (loggedInUserInfo.roleId === 4 || loggedInUserInfo.roleId === 5) {
                                                            //     this.router.navigate(["/mscvp/profile"]);
                                                            // }
                                                            else if ((loggedInUserInfo.tpm === 'true' && loggedInUserInfo.mscvp === 'true') ||
                                                                (loggedInUserInfo.tpm === 'true' && loggedInUserInfo.webForms === 'true') ||
                                                                (loggedInUserInfo.mscvp === 'true' && loggedInUserInfo.webForms === 'true')) {
                                                                this.access();
                                                                this.webForms = (loggedInUserInfo.webForms === 'true') ? true : false;
                                                                this.mscvp = (loggedInUserInfo.mscvp === 'true') ? true : false;
                                                                this.tpm = (loggedInUserInfo.tpm === 'true') ? true : false;
                                                            }
                                                            else if (loggedInUserInfo.webForms === "true" && (loggedInUserInfo.userType === 'internal' || this.loggedInUserInfo.userType === 'admin')) {
                                                                const token1 = this.localstorage.retrieve("token")
                                                                window.location.href = environment.webFormsUrl + `/webForms/dashboard?token=${btoa(token1)}&loginId=${btoa(this.loginModel.loginId)}&password=${btoa(this.loginModel.password)}`

                                                            }
                                                            else if (loggedInUserInfo.webForms == "true" && loggedInUserInfo.userType === 'external') {
                                                                this.mfa()
                                                            }
                                                            else if (loggedInUserInfo.webForms === 'true') {
                                                                this.webForms = true
                                                                window.location.href = environment.webFormsUrl + `/webForms/dashboard?token=${btoa(token1)}&loginId=${btoa(this.loginModel.loginId)}&password=${btoa(this.loginModel.password)}`
                                                            }
                                                            else if (loggedInUserInfo.mscvp === 'true') {
                                                                this.mscvp = true
                                                                this.router.navigate(["/mscvp/profile"]);
                                                            }
                                                            else if (loggedInUserInfo.tpm === 'true') {
                                                                this.tpm = true
                                                                // window.open('/webForms/inbox' , '_self')
                                                            }
                                                            else {
                                                                this.router.navigate(["/mscvp/profile"]);
                                                            }
                                                            this.session.store(
                                                                "userRole",
                                                                loggedInUserInfo.defaultFlowName
                                                            );
                                                        } else {
                                                            this.signInIcon = "pi pi-lock"
                                                            this.errorMsg =
                                                                "Access denied. Please contact Admin !";
                                                        }
                                                    } else {
                                                        this.signInIcon = 'pi pi-lock';
                                                        this.errorMsg =
                                                            "Sorry! your account is In active. Please contact Admin !";
                                                    }
                                                },
                                                (error) => {
                                                    this.signInIcon = 'pi pi-lock';
                                                    this.errorMsg =
                                                        "Sorry! something went wrong. Please contact Admin !";
                                                }
                                            );
                                    } else {
                                        this.signInIcon = 'pi pi-lock';
                                        this.errorMsg =
                                            "Authentication Failed: Invalid Username or Password";
                                        this.router.navigate(["login"]);
                                    }
                                },
                                (error) => {
                                    this.signInIcon = 'pi pi-lock';
                                    this.errorMsg =
                                        "Something went wrong! please contact admin.";
                                }
                            );
                    }
                    else if ((this.loginModel.loginId == null ||
                        this.loginModel.loginId == "") &&
                        (this.loginModel.password == null ||
                            this.loginModel.password == "")) {
                        this.errorMsg = "Please enter Username and Password.";
                        this.loader = false;
                    }
                    else if (this.loginModel.loginId == null ||
                        this.loginModel.loginId == "") {
                        this.errorMsg = "Please enter Username.";
                        this.loader = false;
                    }
                    else if (this.loginModel.password == null ||
                        this.loginModel.password == "") {
                        this.errorMsg = "Please enter Password.";
                        this.loader = false;
                    }
                    else if (!this.captchaInput) {
                        this.errorMsg = "Please Enter Captcha."
                        this.loader = false;
                    }

                }
            }, err => {
                this.loader = false;
            })
        // else {
        //    this.errorMsg = ""
        // }
    }
    encryptPassword(password: string): string {
        console.log(password, "password")
        const PUBLIC_KEY = this.encryptedKey
        const encryptor = new JSEncrypt();
        encryptor.setPublicKey(PUBLIC_KEY);
        const encrypted = encryptor.encrypt(password);
        console.log("Encrypted Password:", encrypted);
        return encrypted || '';
    }
    encryptUserName(userName: string): string {
        console.log(userName, "userName")
        const PUBLIC_KEY = this.encryptedKey
        const encryptor = new JSEncrypt();
        encryptor.setPublicKey(PUBLIC_KEY);
        const encrypted = encryptor.encrypt(userName);
        console.log("Encrypted userName:", encrypted);
        return encrypted || '';
    }
    passwordToggleFieldTextType() {
        this.passwordTextType = !this.passwordTextType;
    }

    showMailDialog() {
        this.dialogHeader = "Forgot Password"
        this.forgot = "forgotPassword";
        this.display = true;
        this.email = "";
        this.forgotPasswordResponse = "";
    }
    showUserNameDialog() {
        this.dialogHeader = "Forgot Username"
        this.forgot = "forgotUserName";
        this.display = true;
        this.email = "";
        this.forgotPasswordResponse = "";
    }

    forgotPassword(email) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
            this.http
                .get(environment.apiUrl + `/user/${this.forgot}/` + email, {
                    responseType: "text",
                })
                .subscribe((data: string) => {
                    this.forgotPasswordResponse = data;
                });
        }
        else if (this.email === undefined || this.email === "" || this.email === null) {
            this.forgotPasswordResponse = "Please enter email";
        }
        else {
            this.forgotPasswordResponse = "Please enter valid email";
        }
    }


    access() {
        this.displayAccess = true;
        this.dialogHeader = "Select the application you want to access."  //"Please select the application"
    }

    msvpLogin() {
        this.router.navigate(["/mscvp/profile"]);
    }

    webFormsLogin() {
        console.log(this.loggedInUserInfo);

        if (this.loggedInUserInfo.webForms === "true" && this.loggedInUserInfo.userType === 'external') {
            this.mfa()
        }
        if (this.loggedInUserInfo.webForms === "true" && (this.loggedInUserInfo.userType === 'internal' || this.loggedInUserInfo.userType === 'admin')) {
            const token1 = this.localstorage.retrieve("token")
            window.location.href = environment.webFormsUrl + `/webForms/dashboard?token=${btoa(token1)}&loginId=${btoa(this.loginModel.loginId)}&password=${btoa(this.loginModel.password)}`

        }
    }
    tpmLogin() {

    }
    handleVerify(response: any): void {
        if (response.isSuccess) {
            // CAPTCHA verification successful, handle accordingly
            console.log('CAPTCHA is correct!');
        } else {
            // CAPTCHA verification failed, handle accordingly
            console.log('CAPTCHA is incorrect!');
        }
    }

    mfa() {
        this.displayMFA = true;
        this.dialogHeader = "Enter OTP"
        this.countdown = 600;
        this.startCountdown();
        this.otpGenerate();
    }

    verifyOtp() {
        this.validateotp()
    }

    moveFocus(currentInput, nextInput) {
        if (currentInput.value.length === 1 && nextInput) {
            nextInput.focus();
        }
    }
    otpGenerate() {
        const req = {
            "loginId": this.loggedInUserInfo.loginId,
        }
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http.put(environment.apiUrl + "/generatePassCode", req, { headers: headers, responseType: "text" })
            .subscribe((data) => {
                console.log(data, "====otp generate");
                if (data == "OTP updated and sent successfully.") {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Your OTP is sent to your registered mail",
                    });
                } else {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "OTP Failed",
                    });
                }
            })
    }

    validateotp() {
        const req = {
            "loginId": this.loggedInUserInfo.loginId,
            "otp": this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5 + this.otp6
        }
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http.get(environment.apiUrl + "/validateOtp/" + `${req.loginId}` + '/' + `${req.otp}`,
            { headers: headers, responseType: "text" })
            .subscribe((data) => {
                console.log(data, "====otp verification===");
                if (data.includes("Otp Verified and Success")) {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "OTP Verified Successfully",
                    });
                    // window.open('/webForms/inbox', '_self')
                    const token1 = this.localstorage.retrieve("token")
                    // window.location.href =   environment.webFormsUrl + `/webForms/dashboard?token=${token1}&loginId=${req.loginId}&password=${this.loginModel.password}`
                    window.location.href = environment.webFormsUrl + `/webForms/dashboard?token=${btoa(token1)}&loginId=${btoa(this.loginModel.loginId)}&password=${btoa(this.loginModel.password)}`

                } else {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "OTP timed out",
                    });
                    this.router.navigate(["/login"])
                }
            })
    }


    getConfig() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/getConfigurations", {
                headers: headers,
                responseType: "text",
            })
            .subscribe((data: any) => {
                const tableData = JSON.parse(data)
                this.session.store('backend_config', tableData)
                this.envName = environment.envName;
                const backendConfig = this.session.retrieve("backend_config");
                if (environment.dev == true) {
                    document.getElementsByTagName("TITLE")[0].innerHTML = "Rehlko-" + environment.envName
                }
                // this.globalColor = backendConfig.globalColor || "#FF8000"
                if (backendConfig && backendConfig.globalColor) {
                    this.globalColor = backendConfig.globalColor;
                    document.documentElement.style.setProperty('--globalColor', this.globalColor);
                } else {
                    this.globalColor = "#a9d4e7"; // Default fallback color
                    document.documentElement.style.setProperty('--globalColor', this.globalColor);
                }
            })
    }
    generateCaptcha() {
        const chars = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz123456789';
        this.captchaText = Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
        this.errorMsg = '';
        this.captchaInput = '';
    }

    clearError(field: string) {
        if (field === 'loginId' || field === 'password' || field === 'captcha') {
            this.errorMsg = "";
        }
    }

    ssoSignIn(username: any) {
        if (!username.loginId) {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Enter UserId",
            });
        }
        else {
            console.log("username", username);
            const url = `${environment.apiUrl}/ssoLogin/${username.loginId}`;
            const headers = new HttpHeaders({
                'Content-Type': 'application/json'
            });
            this.http.get<any>(url, { headers: headers })
                .subscribe(
                    (data) => {
                        console.log("API Response:", data);
                        if (data.userType === 'EXTERNAL_USER') {
                            this.userForm = true;
                            this.nonSsoUser = true;
                            this.btn = "Sign In";
                            this.signIn(username);
                        } else if (data.userType === 'INTERNAL_USER') {
                            this.userForm = true;
                            this.nonSsoUser = false;
                            this.btn = "Next";
                            // this.oauthService.initCodeFlow();
                            this.oauthService.initImplicitFlow();
                        } else if (data.error === 'User not found in database') {
                            this.messageService.add({
                                severity: "error",
                                summary: "Error",
                                detail: "User Not Registered",
                            });
                        }
                    },
                    (error) => {
                        this.userForm = false;
                        this.nonSsoUser = false;
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "User Not Registered",
                        });
                    }
                );
            // const data = { "login_id": "mpediredla", "userType": "INTERNAL_USER", "message": "User exists, proceed to next step", "status": "A" }
            //     const data = { "login_id": "mpediredla", "userType": "INTERNAL_USER", "message": "User exists, proceed to next step", "status": "A" }
            //     if (data.userType === 'EXTERNAL_USER') {
            //         this.fullForm = true;
            //         this.sso = false;

            //     } else if (data.userType === 'INTERNAL_USER') {
            //         this.fullForm = false;
            //         this.sso = true;
            //         this.oauthService.initImplicitFlow();
        }
    }
}
